import { createContext, useContext, useState } from "react";

const emptyMap = () => ({
  id: null,
  title: "",
  issue: "",
  mode: "together",
  partner_a_name: "",
  partner_b_name: "",
  position_a: "",
  position_b: "",
  concerns_a: "",
  concerns_b: "",
  needs_a: [],
  needs_b: [],
  solutions: [],
  communication_tips: {},
  reflection: { promising: "", unmet: "", improve: "", changed: "" },
  history: [],
});

const LabContext = createContext(null);

export function LabProvider({ children }) {
  const [map, setMap] = useState(emptyMap());
  const [step, setStep] = useState(0);
  const [aiHelped, setAiHelped] = useState(false);

  const update = (patch) => setMap((m) => ({ ...m, ...patch }));
  const reset = () => {
    setMap(emptyMap());
    setStep(0);
    setAiHelped(false);
  };
  const loadMap = (data) => {
    setMap({ ...emptyMap(), ...data });
    setStep(0);
    setAiHelped(false);
  };

  return (
    <LabContext.Provider value={{ map, setMap, update, step, setStep, reset, loadMap, aiHelped, setAiHelped }}>
      {children}
    </LabContext.Provider>
  );
}

// Helpers so components can show real partner names with sensible fallbacks.
export const nameA = (map) => (map?.partner_a_name || "").trim() || "Partner A";
export const nameB = (map) => (map?.partner_b_name || "").trim() || "Partner B";

// Whether the session is being completed by one person alone (vs. both partners together).
export const isSolo = (map) => map?.mode === "solo";

export const useLab = () => useContext(LabContext);
